import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'outcomesGroupComparison',
    label: 'Outcomes Group Comparison Report',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
